module.exports = __webpack_public_path__ + "img/edit-icon.76cee553.svg";